import React, { ChangeEvent, forwardRef, useState } from 'react';
import cn from 'classnames';
import { Button, CustomLabel, EasyModal } from '@ui';

import Icon from '../icons';
type TextAreaProps = {
  label?: string;
  defaultValue?: string;
  disabled?: boolean;
  error?: string;
  placeholder?: string;
  height?: number;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  popupModal?: boolean;
};
const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>((props, forwardedRef) => {
  const {
    label,
    placeholder = '',
    onChange,
    defaultValue,
    error,
    disabled = false,
    height = 200,
    popupModal,
    ...rest
  } = props;
  const [popupModalState, setPopupModalState] = useState(false);
  function onClose() {
    setPopupModalState(false);
  }
  const [, setTextAreaValue] = useState<string>(defaultValue || '');
  const textAreaClassName = cn(
    'border-[1px]',
    disabled ? 'text-2color bg-b_light' : 'text-0color',
    error ? 'border-basic_red' : 'border-b_dark',
    'text-sm',
    'py-[15px]',
    'px-[10px]',
    'relative',
    'bg-white',
    'rounded-defaultR',
    'flex',
    'items-center',
    'block',
    'w-full',
    'min-h-[84px]',
  );
  function handleChangeTextAreaValue(event: ChangeEvent<HTMLTextAreaElement>) {
    setTextAreaValue(event.target.value);
    onChange?.(event);
  }
  return (
    <div>
      {label && (
        <div className="mb-[6px]">
          <CustomLabel label={label} />
        </div>
      )}
      <div className="relative">
        <textarea
          ref={forwardedRef}
          // defaultValue={defaultValue}
          name={label}
          value={defaultValue}
          placeholder={placeholder}
          onChange={handleChangeTextAreaValue}
          className={textAreaClassName}
          style={{
            minHeight: `${height}px`,
            ...{ ...(popupModal ? { paddingRight: '25px' } : {}) },
          }}
          {...rest}
        />
        {popupModal && (
          <div
            onClick={() => setPopupModalState(true)}
            className=" cursor-pointer absolute bottom-[8px] right-[7px]"
          >
            <Icon size={13.5} name="WindowIcon" className="text-4color" />
          </div>
        )}
      </div>
      {!!error && true && (
        <div className="mt-[1px] whitespace-nowrap text-sm text-basic_red">{error}</div>
      )}
      {popupModal && (
        <Modal
          onChange={handleChangeTextAreaValue}
          value={defaultValue}
          show={popupModalState}
          onClose={onClose}
        />
      )}
    </div>
  );
});

TextArea.displayName = 'TextArea';

export default TextArea;

const Modal = ({ show, onClose, value, onChange }) => {
  const [localState, setLocalState] = useState<React.ChangeEvent<HTMLTextAreaElement>>();

  function handleSaveChanges() {
    onChange(localState);
    onCloseLocal();
  }
  function onCloseLocal() {
    onClose();
    setLocalState(undefined);
  }
  return (
    <EasyModal
      variant="largeW1164"
      withoutContentPadding
      withoutFooter
      show={show}
      onClose={onCloseLocal}
    >
      {show && (
        <div className="relative px-[24px] pt-[24px]">
          <div>
            <TextArea
              onChange={setLocalState}
              defaultValue={localState?.target.value || value}
              height={700}
            />
          </div>
          <div className="sticky bottom-0 bg-white pb-[24px] pt-[8px] flex items-center justify-between">
            <Button fill="linked" onClick={onClose} label="Отменить" />
            <Button onClick={handleSaveChanges} label="Сохранить" />
          </div>
        </div>
      )}
    </EasyModal>
  );
};
